import { useCallback } from "react";
import { generatePath, useNavigate } from "react-router";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { PATHS } from "@/routes/paths";

import { START_GUIDE_QUERY } from "@/components/features/_shared/repository/start-guide/query/schema";
import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { OptionCreate_EditPage_Mutation } from "./mutation";
import { viewModelToOptionInputConverter } from "../../_common/view-model-to-option-input";

import type { ProductOptionFormModel } from "../../../type";

type Props = {
	resetForm: () => void;
};

export const useOptionEditMutation = ({ resetForm }: Props) => {
	const navigate = useNavigate();
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();
	const { mutationFunc } = useCustomMutation(OptionCreate_EditPage_Mutation);
	/**
	 * @todo 副作用を UI で定義
	 */
	const onUpdate = useCallback(
		async (
			viewModel: ProductOptionFormModel["ViewModel"], //
		) => {
			showLoadingScreenCallback();
			const input = viewModelToOptionInputConverter({ viewModel });
			const { errors } = await mutationFunc({
				variables: { input },
				refetchQueries: [{ query: START_GUIDE_QUERY, variables: { hotelID: input.hotelID } }],
			}).finally(hideLoadingScreenCallback);

			if (!errors) {
				notifyUserEventInfo({
					title: "オプションを作成しました",
				});
				resetForm();
				const hotelID = input.hotelID;
				setTimeout(() => navigate(generatePath(PATHS.HOTEL.ITEMS.OPTION.TOP, { hotelID })), 300);
			}
		},
		[hideLoadingScreenCallback, mutationFunc, navigate, resetForm, showLoadingScreenCallback],
	);

	return { onUpdate };
};
